import pAll from 'p-all';
import PromisesQueueCalls, {
  PromisesQueueEventType,
} from '../lib/utils/PromisesQueueCalls';
import { syncAllProcess } from '~/lib/sync/syncAllProcess';
import { NomadDB } from '~/db/NomadDB';
import { nomadApi } from '~/lib/api/fetch';
import { getStats } from '~/lib/stats/stats-by-lb';
import { TasksManager } from '~/lib/task/TasksManager';
import { ProgressMamager } from '~/lib/utils/ProgressManager';
export enum WorkerMessageInType {
  Init = 'init',
  Sync = 'sync',
  Load = 'load',
  Cancel = 'cancel',
}

export enum WorkerMessageOutType {
  InitComplete = 'initComplete',
  LoadComplete = 'loadComplete',
  SyncLoaded = 'syncLoaded',
  SyncComplete = 'syncComplete',
  CancelComplete = 'cancelComplete',
  Error = 'error',
}

export class WorkerMessageInInitValue {
  public apiHeaders: Headers;
  public apiRefreshHeaders: Headers;
  public apiBase: string;
  public memberId: string;
  public profile: Profile;
  constructor(
    apiBase: string,
    apiHeaders: Headers,
    apiRefreshHeaders: Headers,
    memberId: string,
    profile: Profile
  ) {
    this.apiHeaders = apiHeaders;
    this.apiRefreshHeaders = apiRefreshHeaders;
    this.apiBase = apiBase;
    this.memberId = memberId;
    this.profile = profile;
  }
}

export class SyncWorker {
  private _memberId: string;
  private _nApi;
  private _db: NomadDB;
  // private _tasksManager: TasksManager;
  private _progressManager: ProgressMamager;
  private _promisesCalls: PromisesQueueCalls;
  private _self;
  // private _asideTask: Function;
  private _profile: Profile;
  private _statsTask: Function;
  constructor(self) {
    this._db = new NomadDB();
    this._promisesCalls = new PromisesQueueCalls();
    this._progressManager = new ProgressMamager();
    this._progressManager.updateSignal.connect((type, value) => {
      this._self.postMessage({
        type,
        value,
      });
    });
    this._promisesCalls.updateSignal.connect((type, value) => {
      this._self.postMessage({
        type,
        value,
      });
      switch (type) {
        case PromisesQueueEventType.ERROR:
          this._self.postMessage({
            type: WorkerMessageOutType.Error,
            value,
          });
          break;
        case PromisesQueueEventType.CANCEL:
          this._self.postMessage({
            type: WorkerMessageOutType.CancelComplete,
          });
          break;
        case PromisesQueueEventType.COMPLETE:
          this._runAsideTask();
          break;
      }
    });
    this._self = self;
    this._self.addEventListener('message', this._handleMessage, false);
  }

  _handleMessage = async (e) => {
    switch (e.data.type) {
      case WorkerMessageInType.Init:
        await this.init(e.data.value);
        break;
      case WorkerMessageInType.Load:
        this.loadTasks(e.data.value);
        break;
      case WorkerMessageInType.Sync:
        this.sync(e.data.value);
        break;
    }
  };

  async init(messageValue: WorkerMessageInInitValue) {
    try {
      const { apiHeaders, apiRefreshHeaders, apiBase, memberId, profile } =
        messageValue;
      this._memberId = memberId;
      this._profile = profile;
      this._nApi = nomadApi(apiBase, apiHeaders, apiRefreshHeaders);
      await this._db.open();
      this._self.postMessage({
        type: WorkerMessageOutType.InitComplete,
      });
    } catch (e) {
      this._self.postMessage({
        type: WorkerMessageOutType.Error,
        valiue: e,
      });
    }
  }

  async cancel() {
    this._progressManager.clear();
    this._promisesCalls.cancel();
    this._statsTask = null;
  }

  async loadTasks(data) {
    try {
      const {
        newProfile,
        contentSynchroFrequencyHour,
        userSynchroFrequencyHour,
        businessSynchroFrequencyHour,
      } = data;

      const tasksManager = new TasksManager(this._db);

      const sync = syncAllProcess(
        this._db,
        this._nApi.fetch,
        newProfile,
        this._profile,
        contentSynchroFrequencyHour,
        userSynchroFrequencyHour,
        businessSynchroFrequencyHour,
        tasksManager
      );

      await sync.getTasks();

      await tasksManager.save();

      this._profile = newProfile;

      this._self.postMessage({
        type: WorkerMessageOutType.LoadComplete,
        value: { tasksLength: tasksManager.length },
      });
    } catch (e) {
      this._self.postMessage({
        type: WorkerMessageOutType.Error,
        value: e,
      });
    }
  }

  async sync({ simultaneousPromises }) {
    await this._runTasks(simultaneousPromises);
  }

  _runAsideTask = async () => {
    const asideTasks = [];
    if (this._statsTask) {
      asideTasks.push(this._statsTask);
    }
    await pAll(asideTasks);
    this._self.postMessage({
      type: WorkerMessageOutType.SyncComplete,
    });
  };

  _getAsideStatsTask = () => {
    this._progressManager.incTotal();
    return async () => {
      await getStats(this._db, this._profile.userContent, this._memberId);
      this._progressManager.incProgress();
    };
  };

  async _runTasks(simultaneousPromises: number = 1) {
    try {
      this._progressManager.clear();

      const tasksManager = new TasksManager(this._db);

      await tasksManager.load();

      if (tasksManager.length) {
        const taskIds = tasksManager.list.map((task) => task.id);
        const strIds = taskIds.join('-');

        const needRefreshStats =
          strIds.includes('progressions') || strIds.includes('sync-content');

        this._statsTask = null;
        if (needRefreshStats) {
          this._statsTask = this._getAsideStatsTask();
        }

        tasksManager.transformPromsiseCalls(
          this._promisesCalls,
          this._db,
          this._nApi.fetch,
          this._progressManager,
          simultaneousPromises
        );

        await this._promisesCalls.execute(simultaneousPromises);
      } else {
        this._self.postMessage({
          type: WorkerMessageOutType.SyncComplete,
        });
      }
    } catch (e) {
      this._self.postMessage({
        type: WorkerMessageOutType.Error,
        value: e,
      });
    }
  }
}
